<template>
  <v-dialog
    v-model="localDialog"
    max-width="90%"
    class="base-dialog"
  >
    <v-card class="base-card pb-4">
      <v-card-title class="card-title">
        <div>Фильтры</div>
        <v-btn
          variant="plain"
          :ripple="false"
          size="20"
          icon
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            v-for="filter in filters"
            v-if="Boolean(dataTypeComponents[getFieldTypeNameById(filter.fieldTypeId)])"
            :key="`${filter.fieldTypeId}-${filter.formTemplateFieldId}`"
            :cols="isXs ? 12 : 4"
          >
            <component
              :is="dataTypeComponents[getFieldTypeNameById(filter.fieldTypeId)]"
              :label="filter.name"
              :model-value="filter.value"
              :key-value="filter.fieldName"
              :autocomplete-items="filter.list"
              hide-details
              @input="val => handleFilterUpdate(filter, val)"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions style="width: 100%;">
        <v-btn
          class="simple-text-button"
          style="margin-left: auto;"
          plain
          :ripple="false"
          @click="close"
        >
          Закрыть
        </v-btn>
        <v-btn
          class="action-btn"
          color="#1971c2"
          style="color: white;"
          @click="apply"
        >
          <v-icon left>
            mdi-filter-outline
          </v-icon>
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getFieldTypeNameById } from '@/enums/fieldType'
import StringInput from '@/components/Spm/Filters/data-filters/StringInput.vue'
import DateInput from '@/components/Spm/Filters/data-filters/DateInput.vue'
import FloatInput from '@/components/Spm/Filters/data-filters/FloatInput.vue'
import IntegerInput from '@/components/Spm/Filters/data-filters/IntegerInput.vue'
import BooleanAutocomplete from '@/components/Spm/Filters/data-filters/BooleanAutocomplete.vue'
import CommonAutocomplete from '@/components/Spm/Filters/data-filters/CommonAutocomplete.vue'

export default {
  name: 'FiltersDialog',

  components: {
    StringInput,
    CommonAutocomplete,
    BooleanAutocomplete,
    IntegerInput,
    FloatInput,
    DateInput,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    isXs: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      localDialog: this.dialog,
      dataTypeComponents: {
        Date: DateInput,
        Email: StringInput,
        Double: FloatInput,
        Integer: IntegerInput,
        PhoneNumber: StringInput,
        Text: StringInput,
        RadioButton: BooleanAutocomplete,
        Autocomplete: CommonAutocomplete,
        Checkbox: BooleanAutocomplete,
      },
    }
  },

  methods: {
    getFieldTypeNameById,
    handleFilterUpdate(filter, val) {
      this.$emit('update:filter', {
        ...filter,
        value: val,
      })
    },
    apply() {
      this.$emit('apply')
    },
    close() {
      this.localDialog = false
    },
  },

  watch: {
    dialog(newVal) {
      this.localDialog = newVal
    },
    localDialog(newVal) {
      if (newVal !== this.dialog) {
        this.$emit('update:dialog', newVal)
      }
    },
  },
}
</script>

<style
  lang="scss"
  scoped
>
.card-title {
  justify-content: space-between;
}
</style>
